import cx from 'classnames'

import styles from './cta-button.module.css'

interface CtaButtonProps {
  href?: string
  onClick?: () => void
  small?: boolean
  className?: string
  children: React.ReactNode
}

export const CtaButton = ({
  href,
  onClick,
  small,
  className,
  children,
}: CtaButtonProps) => {
  const classNames = cx(styles.ctaButton, {
    [`${className}`]: className,
    [styles.ctaButtonSmall]: small,
  })

  if (href) {
    return (
      <a href={href} onClick={onClick} className={classNames}>
        {children}
      </a>
    )
  }

  return (
    <button onClick={onClick} className={classNames}>
      {children}
    </button>
  )
}
